import { api } from "api/api";
import { AxiosError } from "axios";
import Horario from "model/gestao/atividades/Horario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";

class HorarioService implements BaseServiceCadastros<Horario> {

    pesquisar(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/horario/pesquisar`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Horario>((resolve, reject): void => {
            api
                .get(`/horario/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(horario: Horario) {
        return new Promise<Horario>((resolve, reject): void => {
            let url = `/horario/incluir`;
            api
                .post(url, JSON.stringify(horario))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(horario: Horario) {
        return new Promise<Horario>((resolve, reject): void => {
            api
                .put(`/horario/editar`, JSON.stringify(horario))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/horario/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default HorarioService;
